import { IconButton, Box, Grid } from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import COLORS from '../../../resources/style/Themes';

interface ChatSideBarProps {
  toggleEmergencyResponseTeam: () => void;
  latitude: number | undefined;
  longitude: number | undefined;
  isOpen: boolean;
}

function ChatSideBar({
  toggleEmergencyResponseTeam,
  latitude,
  longitude,
  isOpen,
}: ChatSideBarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
      }}
    >
      <Grid container justifyContent="center" sx={{ paddingBottom: '10px' }}>
        <Grid>
          <IconButton
            sx={{
              height: '30px',
              width: '30px',
              minWidth: '30px',
              mt: 0.5,
              transition: 'transform 0.2s ease',
              '&:hover': {
                color: COLORS.BLUE_CRAYOLA,
                transform: 'scale(1.25)',
              },
            }}
            onClick={() => toggleEmergencyResponseTeam()}
          >
            {isOpen ? (
              <ChevronLeftRounded style={{ fontSize: 26 }} />
            ) : (
              <ChevronRightRounded style={{ fontSize: 26 }} />
            )}
          </IconButton>
        </Grid>
      </Grid>
      {latitude && longitude && (
        <Grid container justifyContent="center">
          <Grid>
            <IconButton
              sx={{
                backgroundColor: COLORS.SAFEGUARD_ORANGE,
                color: COLORS.WHITE,
                border: 'none',
                borderRadius: '10px',
                height: '45px',
                width: '45px',
                minWidth: '45px',
                '&:hover': {
                  backgroundColor: COLORS.HOVER_ORANGE,
                },
              }}
              onClick={() =>
                window.open(
                  `https://maps.google.com?q=${latitude},${longitude}`,
                )
              }
            >
              <LocationOnIcon style={{ color: COLORS.WHITE, fontSize: 22 }} />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default ChatSideBar;
